import React, { Component } from "react"

import Layout from "../../components/Layout/layout"
import SEO from "../../components/seo"

import InstaImage from './components/InstaImage/InstaImage'

class WorkPage extends Component {
  state = {
    smallScreen: false,
    modal: { name: "" },
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this))
    this.resize()
  }

  resize() {
    this.setState({ smallScreen: window.innerWidth <= 840 })
  }

  render() {
    const { data } = this.props;
    let workData = this.props.data.allWorkJson.nodes[0]
    return (
      <Layout page={"work"}>
        <SEO title="Work" description="Skyink's art gallery." />
        <h1 className="title">{workData.title}</h1>
        <div className="text">{workData.text}</div>
        <div
          className={
            this.state.smallScreen
              ? "grid-container-small"
              : "work-grid-container"
          }
        >
          {data.allInstaNode.edges.map(({ node } = {}, i) => node ? (
            <InstaImage node={node} key={i} />
          ) : null)}
        </div>
      </Layout>
    )
  }
}
export default WorkPage

export const query = graphql`
  query {
    allInstaNode(
        limit: 50
        sort: {
          fields: timestamp,
          order: DESC
        }
        filter: {
          mediaType: {
            eq: "IMAGE"
          }
        }
      ) {
      edges {
        node {
          id
          likes
          comments
          mediaType
          # preview
          original
          timestamp
          # caption
          localFile {
            childImageSharp {
              fixed(width: 300, height: 300) {
                ...GatsbyImageSharpFixed
              }
            }
            # childImageSharp {
            #   fluid(quality: 70, maxWidth: 600, maxHeight: 600) {
            #     ...GatsbyImageSharpFluid_withWebp
            #   }
          }
        }
      }
    }
    allWorkJson {
      nodes {
        id
        title
        description
        text
      }
    }
  }
`
